import { Container } from "reactstrap";
import cn from "classnames";
import styles from "./styles.module.scss";

export const Content = ({ className, title, content }) => {
  return (
    <section className={cn(styles.Content, className)}>
      <Container className="py-5 section">
        {title && <h2 className={cn(styles.title)}>{title}</h2>}
        <div className={cn(styles.desc)} dangerouslySetInnerHTML={{ __html: content }} />
      </Container>
    </section>
  );
};

export default Content;
